export const entityNameMap = {
  BajaEntity: 'BAJAS',
  GenderEntity: 'GENEROS',
  SectionEntity: 'SECCIONES',
  ElectionEntity: 'ELECCIONES',
  UserEntity: 'USUARIOS',
  Role: 'ROLES',
  UserRole: 'GESTION_RELACIONES',
  NativePopulationRegistry: 'PADRONES_NATIVOS',
  Calle: 'CALLES',
  CalleAlternativa: 'CALLES_SINONIMO',
  PadronEntity: 'PADRONES',
  CanalImportacionEntity: 'CANAL_IMPORTACION',
  CampoCanalEntity: 'CAMPO_CANAL',
  ClaimEntity: 'RECLAMOS',
  ConsultaRenaperEntity: 'CONSULTA_RENAPER',
  ElectorEntity: 'ELECTORES',
  CalleExcepcion: 'EXCEPCIONES',
  BarrioAlternativo: 'BARRIOS_ALTERNATIVOS',
  BarrioAlternativoSinonimo: 'BARRIO_ALTERNATIVO_SINONIMO',
  CodigoPostal: 'CODIGO_POSTAL',
  Roles: 'ROLES',
  'Gestion Relaciones': 'GESTION_RELACIONES',
  Barrio: 'BARRIOS',
  CircuitEntity: 'CIRCUITOS',
  EstablishmentEntity: 'ESTABLECIMIENTOS',
  ParameterEntity: 'PORTAL_CONSULTA_PARAMETROS',
  Residente: 'RESIDENTE',
  ResidenteHistoricoEntity: 'IMPORTACIONES',
  Authority: 'POSTULANTES',
  Delegate: 'DELEGADOS',
  DelegatesDesignation: 'DELEGADOS-DESIGNADOS',
  Observaciones: 'OBSERVACIONES',
  PaymentClaimDelegate: 'RECLAMOS_PAGOS_DELEGADOS',
};
